import { render, staticRenderFns } from "./DocumentDetailsSection.vue?vue&type=template&id=995e9c46&"
import script from "./DocumentDetailsSection.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports